import React from 'react';
import { Card } from '../components/UI/Card';
import { Button } from '../components/UI/Button';
import { Mail, Linkedin, Instagram } from 'lucide-react';
import { Link } from 'react-router-dom';
interface PartnerWithUsProps {
  openRegistrationForm?: () => void;
  openHostSalonForm?: () => void;
}
export const PartnerWithUs = ({
  openRegistrationForm,
  openHostSalonForm
}: PartnerWithUsProps) => {
  return <div className="pt-20" data-id="element-2346">
      <section className="py-16 bg-secondary/5" data-id="element-2347">
        <div className="container mx-auto px-4" data-id="element-2348">
          <h1 className="text-4xl font-bold text-center text-secondary-dark mb-6" data-id="element-2349">
            Partner With Us
          </h1>
          <p className="text-center text-lg text-secondary max-w-3xl mx-auto" data-id="element-2350">
            Join forces with The Networking Salon to create meaningful
            connections, share resources, and build a stronger community
            together.
          </p>
        </div>
      </section>
      <section className="py-16" data-id="element-2351">
        <div className="container mx-auto px-4" data-id="element-2352">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16" data-id="element-2353">
            <div data-id="element-2354">
              <h2 className="text-3xl font-bold text-secondary-dark mb-6" data-id="element-2355">
                Why Partner With Us?
              </h2>
              <div className="space-y-4" data-id="element-2356">
                <p className="text-secondary" data-id="element-2357">
                  The Networking Salon brings together ambitious professionals,
                  entrepreneurs, and changemakers across 30+ cities worldwide.
                  Our community is built on authentic connections, resource
                  sharing, and creating opportunities.
                </p>
                <p className="text-secondary" data-id="element-2358">
                  By partnering with us, your organization gains access to a
                  diverse network of engaged individuals who are actively
                  seeking to grow, collaborate, and make an impact in their
                  fields.
                </p>
                <p className="text-secondary" data-id="element-2359">
                  We believe in creating partnerships that provide mutual value
                  and align with our mission of connecting young leaders to
                  networks, ideas, and opportunities worldwide.
                </p>
              </div>
            </div>
            <div data-id="element-2360">
              <Card className="p-0 overflow-hidden" data-id="element-2361">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gLvZ6fTjQSpPs86zUNEWZz/Group.jpg" alt="The Networking Salon event" className="w-full h-64 object-cover" data-id="element-2362" />
              </Card>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-2363">
            <Card className="flex flex-col items-center text-center p-8" data-id="element-2364">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-2365">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-2366"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2367">
                Event Collaborations
              </h3>
              <p className="text-secondary" data-id="element-2368">
                Co-create workshops, panels, and networking events that bring
                value to both our communities.
              </p>
            </Card>
            <Card className="flex flex-col items-center text-center p-8" data-id="element-2369">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-2370">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-2371"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2372">
                Resource Sharing
              </h3>
              <p className="text-secondary" data-id="element-2373">
                Exchange knowledge, tools, and platforms to support each other's
                growth and impact.
              </p>
            </Card>
            <Card className="flex flex-col items-center text-center p-8" data-id="element-2374">
              <div className="w-16 h-16 flex items-center justify-center bg-secondary/10 rounded-full mb-4" data-id="element-2375">
                <div className="w-8 h-8 border-2 border-secondary rounded-full" data-id="element-2376"></div>
              </div>
              <h3 className="text-xl font-bold text-secondary-dark mb-2" data-id="element-2377">
                Community Connections
              </h3>
              <p className="text-secondary" data-id="element-2378">
                Access our network of professionals and help your audience find
                valuable connections.
              </p>
            </Card>
          </div>
          <div className="bg-secondary/5 rounded-lg p-8 border border-gray-200 mb-16" data-id="element-2379">
            <h2 className="text-2xl font-bold text-secondary-dark mb-6 text-center" data-id="element-2380">
              Get In Touch
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2381">
              <Card className="flex flex-col items-center text-center p-6" data-id="element-2382">
                <Mail size={32} className="mb-4 text-secondary" data-id="element-2383" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-2384">
                  Email Us
                </h3>
                <p className="text-secondary mb-4" data-id="element-2385">
                  Send us a message to discuss partnership opportunities.
                </p>
                <a href="mailto:partner@thenetworkingsalon.live" className="text-primary hover:underline" data-id="element-2386">
                  partner@thenetworkingsalon.live
                </a>
              </Card>
              <Card className="flex flex-col items-center text-center p-6" data-id="element-2387">
                <Instagram size={32} className="mb-4 text-secondary" data-id="element-2388" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-2389">
                  Instagram
                </h3>
                <p className="text-secondary mb-4" data-id="element-2390">
                  Follow us for updates and direct message us.
                </p>
                <a href="https://www.instagram.com/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-id="element-2391">
                  @thenetworkingsalon
                </a>
              </Card>
              <Card className="flex flex-col items-center text-center p-6" data-id="element-2392">
                <Linkedin size={32} className="mb-4 text-secondary" data-id="element-2393" />
                <h3 className="text-lg font-bold text-secondary-dark mb-2" data-id="element-2394">
                  LinkedIn
                </h3>
                <p className="text-secondary mb-4" data-id="element-2395">
                  Connect with us professionally and explore our content.
                </p>
                <a href="https://www.linkedin.com/showcase/thenetworkingsalon/" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline" data-id="element-2396">
                  The Networking Salon
                </a>
              </Card>
            </div>
          </div>
          <div className="text-center" data-id="element-2397">
            <h2 className="text-2xl font-bold text-secondary-dark mb-6" data-id="element-2398">
              Join Our Community
            </h2>
            <p className="text-secondary mb-8 max-w-2xl mx-auto" data-id="element-2399">
              Want to be part of The Networking Salon? Join as a member or host
              a salon in your city.
            </p>
            <div className="flex flex-wrap justify-center gap-4" data-id="element-2400">
              <Link to="/joinnow" data-id="element-2401">
                <Button data-id="element-2402">Join a Salon</Button>
              </Link>
              <Button variant="outline" onClick={openHostSalonForm} data-id="element-2403">
                Host a Salon
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>;
};